import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminSocialMedia from "../../../../views/admin/cms/socialMedia/AdminSocialMedia";

const AdminSocialMediaPage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminSocialMedia />
      <AdminFooter />
    </div>
  );
};

export default AdminSocialMediaPage;